import { hospitalsTypes } from "../constantes/actionTypes"

const initialState = []

export const hospitals = (state = initialState, action) => {
    switch (action.type) {
        case hospitalsTypes.GET_ALL_HOSPITALS_SUCCESS:
            return action.payload
        case hospitalsTypes.GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_SUCCESS:
            return state.concat(action.payload)
        case hospitalsTypes.UPDATE_HOSPITAL_SUCCESS: {
            const hospitales = state.map(item => {
                if (item.id_Hospital === action.payload.id_Hospital)
                    return action.payload
                return item
            })
            return hospitales
        }
        case hospitalsTypes.NEW_HOSPITAL_SUCCESS:
            return [...state, action.payload]
        case hospitalsTypes.DELETE_HOSPITAL_SUCCESS:
          return state.filter(item => item.id_Hospital !== action.payload)
        case hospitalsTypes.NEW_HOSPITAL_FAILURE:
        case hospitalsTypes.UPDATE_HOSPITAL_FAILURE:
        case hospitalsTypes.DELETE_HOSPITAL_FAILURE:
            return state
        case hospitalsTypes.GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_FAILURE:
        case hospitalsTypes.GET_ALL__HOSPITALS_FAILURE:
            return initialState
        case hospitalsTypes.CLEAR_HOSPITALS_LIST:
            return initialState
        default:
            return state
    }
}